<template>
	<form @submit.prevent="submit">
		<div v-if="type==='Upload'">
			<div class="form-group">
				<label for="service">Service</label>
				<span
					v-if="servicesLoading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
				></span>
				<input :disabled="serviceName" class="form-control" list="services" v-model="git.serviceName">
				<datalist id="services">
					<option v-for="service in services" :key="service">{{service}}</option>
				</datalist>
				<input v-if="git.serviceName" type="file" accept=".json" @change="singleServiceImport($event)" />
			</div>
			
			<ImportEverythingDialog ref="importEverythingDialog" v-if="results" :results="results"/>
			<ErrorAlert v-if="error" :error="error" />
		</div>
		<div v-if="type==='Pull' || type==='Push'" class="form-container">
			<div v-if="isSuccess && isPush()" class="alert alert-success" role="alert">
				<h4 class="text-success">Success</h4>
			</div>
			<ErrorAlert v-if="error" :error="error" />
			<div :class="{'d-flex': pushErrors!=null}">
				<div :class="{'col-3': pushErrors!=null }">
					<div class="form-group">
						<label for="username">Username*</label>
						<input
							type="text"
							class="form-control"
							name="username"
							placeholder="Username"
							v-model="git.username"
							:class="{ 'is-invalid': isInvalid.username }"
						/>
					</div>
					<div class="form-group">
						<label for="username">Password*</label>
						<input
							type="password"
							class="form-control"
							name="firstName"
							placeholder="Password"
							v-model="git.password"
							autocomplete="new-password"
							:class="{ 'is-invalid': isInvalid.password }"
						/>
					</div>
					<div class="form-group">
						<label for="username">Git URL*</label>
						<input
							type="text"
							class="form-control"
							name="firstName"
							placeholder="Git URL"
							v-model="git.gitUrl"
							:class="{ 'is-invalid': isInvalid.gitUrl }"
						/>
					</div>
					<div v-if="isPush()" class="form-group">
						<label for="commitMessage">Commit message</label>
						<input
							type="text"
							class="form-control"
							name="commitMessage"
							placeholder="Commit message"
							v-model="git.commitMessage"
						/>
					</div>
					<b-form-checkbox @change="withBranch()" class="form-group">
						Branch
						<span
							v-if="branchesLoading && type === 'Pull'"
							class="spinner-border spinner-border-sm mr-2"
							role="status"
							aria-hidden="true"
						></span>
					</b-form-checkbox> 
					<div v-if="isBranch && (!branchesLoading || type !== 'Pull')" class="form-group">
						<label for="branch">Branch</label>
						<span
							v-if="branchesLoading && type !== 'Pull'"
							class="spinner-border spinner-border-sm mr-2"
							role="status"
							aria-hidden="true"
						></span>
						<input class="form-control" list="branches" v-model="git.branch">
						<datalist id="branches">
							<option v-for="branch in branches" :key="branch">{{branch}}</option>
						</datalist>
					</div>
					<b-form-checkbox @change="revertToSha()" class="form-group">Revert to commit sha</b-form-checkbox> 
					<div v-if="type==='Pull' && isRevert" class="form-group">
						<label for="commitSha">Commit sha</label>
						<input
							type="text"
							class="form-control"
							name="commitSha"
							placeholder="Commit Sha"
							v-model="git.commitSha"
						/>
					</div>
					<div class="form-group">
						<p v-if="errMsg" class="text-danger">{{ errMsg }}</p>
					</div>
				</div>
				<div v-if="pushErrors!=null" class="col-9">
					<table class="table mt-2">
						<thead>
							<tr>
								<th>Service</th>
								<th>Status</th>
								<th>Message</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(result, index) of pushErrors" :key="index" :class="{'text-danger': result.status==='ERROR', 'text-success': result.status==='OK'}">
								<td>{{result.serviceName}}</td>
								<td>{{result.status}}</td>
								<td>{{result.error ? result.error.localizedMessage : ''}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<ImportEverythingDialog ref="importEverythingDialog" v-if="results" :results="results"/>
			<div class="d-flex justify-content-end">
				<button v-if="type!=='Pull'" class="btn btn-secondary mr-3" type="button" @click="close">
					Close
				</button>
				<button class="btn btn-primary" type="submit">
					<span
					v-if="loading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
					></span>
					{{type}}
				</button>				
			</div>
		</div>
	</form>       
</template>

<script>
import GitConfig from '../../services/git-config';
import LocalFsService from '../../services/local-fs';
import ImportEverythingDialog from './ImportEverythingDialog'
import ErrorAlert from '../../components/shared/ErrorAlert';

export default {
	name: 'GitConfig',
	components: {
		ErrorAlert,
		ImportEverythingDialog
	},
	props: {
		type: String,
		serviceName: String
	},
	data() {
		return {
			gitRequiredProps: ['username', 'password', 'gitUrl'],
			git: {
				username: '',
				password: '',
				gitUrl: '',
			},
			isInvalid: {
				username: false,
				password: false,
				gitUrl: false,
			},
			errMsg: null,
			loading: false,
			branches: [],
			services: [],
			branchesLoading: false,
			servicesLoading: false,
			error: null,
			pushErrors: null,
			results: null,
			isRevert: false,
			isBranch: false,
			isSuccess: false
		};
	},
	methods: {
		isPush() {
			return this.type==='Push';
		},
		getData() {
			return this.git;
		},
		setData(newGit) {
			return this.git = newGit;
		},
		revertToSha() {
			this.isRevert = !this.isRevert;
			this.git.commitSha = null;
		},
		withBranch() {
			this.isBranch = !this.isBranch;
			this.git.branch = null;
			this.loadBranches();
		},
		submit() {
			if (this.validate()) {
				this.errMsg = 'Please provide values in required fields.';
				return;
			}
			this.loading = true;
			this.isSuccess = false;
			this.pushErrors = null;

			GitConfig.instance()['setGitConfig' + this.type](this.git)
				.then((res) => {
					this.loading = false;
					this.error = null;
					this.errMsg = null;
					this.results = res.data;
					this.isSuccess = true;
					if (this.type == "Pull") {
						this.$emit("remoteDataReceived", res.data);
					} else if (this.type == "Push"){
						this.$emit('resizeDialog', 'md');
					}
				})
				.catch((err) => {
					this.loading = false;
					this.errMsg = null;
					this.error = err;
					if (
						this.type=='Push' && 
						err &&
						err.response &&
						err.response.data &&
						err.response.data.push
					) {
						this.$emit('resizeDialog', 'xl');
						this.pushErrors = err.response.data.push;
					}
				});
			
		},
		loadBranches() {
			if (this.validate()) {
				this.errMsg = 'Please provide values in required fields.';
				return;
			}
			this.branchesLoading = true;

			GitConfig.instance().loadBranches(this.git)
				.then((res) => {
					this.branchesLoading = false;
					this.branches = res.data;							
				})
				.catch((err) => {
					this.branchesLoading = false;
					this.errMsg = null;
					this.error = err;
				});
		},
		loadConfigurableServices() {
			this.servicesLoading = true;

			GitConfig.instance().loadConfigurableServices()
				.then((res) => {
					this.servicesLoading = false;
					this.services = res.data;							
				})
				.catch((err) => {
					this.servicesLoading = false;
					this.errMsg = null;
					this.error = err;
				});
		},
		close() {
			this.$emit('close');
		},
		singleServiceImport(event){
			LocalFsService.instance()
				.load(event.target.files)
				.then(importData => {
					GitConfig.instance().loadLocal(this.git)
					.then((res) => {
						this.loading = false;
						this.error = null;
						this.errMsg = null;	
						res.data[0].gitBody = JSON.stringify(importData);
						this.results = res.data;
					})
					.then(() => {						
							this.$refs.importEverythingDialog.open(this.git);
						})
					.catch((err) => {
						this.loading = false;
						this.errMsg = null;
						this.error = err;
					});
				})
		},
		validate() {
			let isInvalid = false;
			this.gitRequiredProps.forEach((k) => {
				this.isInvalid[k] = !this.git[k];
				if (this.isInvalid[k]) {
					isInvalid = true;
				}
			});
			return isInvalid;
		},
		resetVal() {
			Object.keys(this.git).forEach((k) => {
				this.isInvalid[k] = false;
			});
		},
	},
	beforeMount(){
		if (this.type == "Upload") {
			this.loadConfigurableServices();
			if (this.serviceName) {
				this.git.serviceName = this.serviceName;
			}
		}
	}
};
</script>

<style scoped>
	.h1-buttons.no-verti::after {
		display: none;
	}
	.alert {
		text-align: start;
	}

	.form-container {
		max-width: 30em;
	}
</style>